import Vue from 'vue'
import Vuex from 'vuex'

import * as actions from './actions'
import * as getters from './getters'

import alerts from './modules/alerts'
import quoteStore from './modules/quote-store'


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    actions,
    getters,
    modules: {
        alerts,
        quoteStore
    },
    strict: debug
})
